import $ from "jquery";

if (document.querySelector(".full-card-slider")) {
    const fullCardSliders = document.querySelectorAll(".full-card-slider__slider");

    fullCardSliders.forEach(slider => {
        $(slider).slick({
            appendArrows: $(slider.closest(".full-card-slider").querySelector(".slider-controls__arrows")),
            prevArrow: "<button type='button' class='slick-prev d-none d-md-block'><i class='fal fa-chevron-left'></i></button>",
            nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
            dots: true,
            appendDots: $(slider.closest(".full-card-slider").querySelector(".slider-controls__dots")),
        });
    });
}